var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9107 4.41058C7.23614 4.08514 7.76378 4.08514 8.08921 4.41058L13.0892 9.41058C13.4147 9.73602 13.4147 10.2637 13.0892 10.5891L8.08921 15.5891C7.76378 15.9145 7.23614 15.9145 6.9107 15.5891C6.58527 15.2637 6.58527 14.736 6.9107 14.4106L11.3214 9.99984L6.9107 5.58909C6.58527 5.26366 6.58527 4.73602 6.9107 4.41058Z",
    fill: "#323031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d105d276fc551531be4a30846a4647c2.svg";
export { ForwardRef as ReactComponent };